import { text } from 'locales';
import { formatYYYMMDDHHMMSS } from 'src/utils/dateFormat';
import { getLocaleFromUrl } from 'src/utils/subdomain';
import { CouponSchema } from './schema';

export class CouponHistory {
  coupon: CouponSchema;
  nameStr: string;
  conditionStr: string;
  expireAtJst: string;

  constructor(coupon: CouponSchema) {
    const translateCoupon = () => {
      const locale = getLocaleFromUrl();
      const i18nText = text(locale);
      if (coupon.discountAmount !== null) {
        return {
          coupon,
          nameStr: i18nText.coupons.discountByAmount(coupon.discountAmount),
          conditionStr: i18nText.coupons.minSettlementAmountRemark(coupon.minSettlementAmount),
          expireAtJst: formatYYYMMDDHHMMSS(coupon.expireAt),
        };
      }
      return {
        coupon,
        nameStr: i18nText.coupons.discountByRate(coupon.discountRate ?? 0),
        conditionStr: i18nText.coupons.minSettlementAmountRemark(coupon.minSettlementAmount),
        expireAtJst: formatYYYMMDDHHMMSS(coupon.expireAt),
      };
    };

    this.coupon = translateCoupon().coupon;
    this.nameStr = translateCoupon().nameStr;
    this.conditionStr = translateCoupon().conditionStr;
    this.expireAtJst = translateCoupon().expireAtJst;
  }
}
